import { v4 as uuidv4 } from 'uuid';
import i18n from '../../../i18n';
import { LabelDesignerTemplateGrid } from './LabelDesignerTemplateGrid';
import { LabelDesignerTemplateGridPluginSettings } from './LabelDesignerTemplateGridPluginSettings';

const t = (value: string) => i18n.t('sidePanel.' + value)

export const LabelDesignerTemplateTab = (): ITab => {
    return {
        id: uuidv4(),
        title: t('service.submenu.labelDesignerTemplate'),
        view: {
            content: LabelDesignerTemplateGridPluginSettings
                ? <LabelDesignerTemplateGrid gridId={uuidv4()} plugin={LabelDesignerTemplateGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}